import { render, staticRenderFns } from "./FramedBot.vue?vue&type=template&id=f646791a&scoped=true&"
import script from "./FramedBot.vue?vue&type=script&lang=js&"
export * from "./FramedBot.vue?vue&type=script&lang=js&"
import style0 from "./FramedBot.vue?vue&type=style&index=0&id=f646791a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f646791a",
  null
  
)

export default component.exports